// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartTable.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var React = require('react');
  var observer = require('mobx-react').observer;
  var connect = require('share/enhancers/Izenda.Connect');
  var Table = require('share/components/controls/DataGrid/Izenda.Table').Table;
  var Column = require('share/components/controls/DataGrid/Izenda.Table').Column;
  var constants = require('logic/data/Izenda.ReportPartSelectionConstants');
  var Paginator = require('share/components/controls/DataGrid/helpers/Izenda.Paginator');
  var Dimensions = require('share/components/hoc/Izenda.Dimensions');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');

  var TABLE_DEF_REPORT_PART = constants.TABLE_DEF_REPORT_PART;
  const { flow, isNil } = require('lodash/fp');
  var ReportPartTable = observer(function(props) {
    var reportPartSelection = props.reportPartSelection;
    var reportPartPageInfo = reportPartSelection.reportPartPageInfo;

    /**
     * render report name cell
     * @method renderReportPartName
     * @param  {object}         dataRow Current Row being render
     * @return {React Componenet}
     */
    var renderReportPartName = function(dataRow) {
      return <div className="overflow-text">{dataRow.title}</div>;
    };

    /**
     * render selected icon
     * @method renderRadioButton
     * @param  {object}         dataRow Current Row being render
     * @return {React Componenet}
     */
    var renderRadioButton = function(dataRow) {
      return (
        <input
          type="radio"
          className="izenda-ReportPartSelectionPopup-ReportPartGrid-radioBtn"
          checked={dataRow === reportPartSelection.selectedReportPart}
        />
      );
    };

    /**
     * render report part type
     * @method renderReportPartTypeCell
     * @param  {object}         dataRow Current Row being render
     * @return {React Componenet}
     */
    var renderReportPartTypeCell = function(dataRow) {
      return (
        <div className="overflow-text">
          <span className={dataRow.typeIcon} />
          {dataRow.reportPartTypeName}
        </div>
      );
    };

    return (
      <section>
        <Table
          dataSource={props.reportPartSelection.currentPageReportPartCollection}
          sortInfo={reportPartPageInfo.colSortDirs}
          onSortChange={reportPartPageInfo.setColSortDirs.bind(reportPartPageInfo)}
          onClickRow={reportPartSelection.setSelectedReportPart.bind(reportPartSelection)}
          minHeight={constants.TABLE_REPORT_PART.height}
          maxHeight={constants.TABLE_REPORT_PART.height}
        >
          <Column {...TABLE_DEF_REPORT_PART.selectedIcon} cell={renderRadioButton} />

          <Column {...TABLE_DEF_REPORT_PART.reportPartTitle} cell={renderReportPartName} />

          <Column {...TABLE_DEF_REPORT_PART.reportPartTypeName} cell={renderReportPartTypeCell} />
        </Table>
        <Paginator
          onChange={reportPartPageInfo.setPageIndex.bind(reportPartPageInfo)}
          onDropdownChange={flow(
            reportPartPageInfo.setPageSize.bind(reportPartPageInfo),
            reportPartPageInfo.setPageIndex.bind(reportPartPageInfo, 1)
          )}
          totalRecords={reportPartPageInfo.totalRecords}
          pageSize={reportPartPageInfo.pageSize}
          pageIndex={reportPartPageInfo.pageIndex}
        />
      </section>
    );
  });

  var GridLayoutReportPartTable = connect()(function(props) {
    if (!props.showReportPart || isNil(props.reportPartSelection.selectedReport)) {
      return null;
    }
    return (
      <GridLayout.Row>
        <GridLayout.Col>
          <ReportPartTable {...props} />
        </GridLayout.Col>
      </GridLayout.Row>
    );
  });

  module.exports = connect()(GridLayoutReportPartTable);
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/ReportPartSelectionPopup/Izenda.ReportPartTable.jsx